import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { map, takeUntil } from 'rxjs/operators';
import { DonationsFeedActions } from '../../state/donations-feed/actions';
import { DonationsListComponent } from '../shared/donations-feed/donations-list.component';
import { selectError } from '../../state/donation-flow';
import {
  selectCardVMs,
  selectLoading,
  selectUniqueDonorsCount,
} from '../../state/donations-feed/selectors';
import { Subject } from 'rxjs';
import { CampaignsActions } from '../../state/campaing/actions';

@Component({
    selector: 'don-recent-donors',
    imports: [CommonModule, DonationsListComponent],
    templateUrl: `./recent-donors.container.html`,
    styleUrls: ['./recent-donors.container.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecentDonorsContainer {
  private store = inject(Store);
  private destroyed$ = new Subject<void>();

  // ✅ siempre emite array (nunca null/undefined)
  vms$ = this.store.select(selectCardVMs).pipe(map((v) => v ?? []));
  donorsCount$ = this.store.select(selectUniqueDonorsCount);
  loading$ = this.store.select(selectLoading);
  error$ = this.store.select(selectError);

  async ngOnInit() {
    this.store.dispatch(DonationsFeedActions.loadRequested());
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onLike(id: string) {
    this.store.dispatch(DonationsFeedActions.likeToggledRequested({ id }));
  }
  onShare(_id: string) {
    /* compartir enlace si aplica */
  }
}
